import LayoutPrimary from '../../layouts/Primary';
import FaqCreate from '../../views/Admin/Config/Faq/FaqCreate';
import FaqIndex from '../../views/Admin/Config/Faq/FaqIndex';
import FaqEdit from '../../views/Admin/Config/Faq/FaqEdit';

export default [
    {
        path: '/faq/create',
        name: 'FaqCreate',
        component: FaqCreate,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
    {
        path: '/faq/index',
        name: 'FaqIndex',
        component: FaqIndex,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
        props: true,
    },
    {
        path: '/faq/edit/:id',
        name: 'FaqEdit',
        component: FaqEdit,
        meta: {
            requiresAuth: true,
            layout: LayoutPrimary,
        },
    },
];
